export function directionFromPoint(point, center) {
  const x = point.x - center.x;
  const y = point.y - center.y;
  if (!Number.isFinite(x) || !Number.isFinite(y) || (x === 0 && y === 0)) return null;
  return mapAngleToBearing((Math.atan2(y, x) * 180) / Math.PI);
}

// Canvas geometry measures clockwise from east; the dial displays compass
// bearings clockwise from north. Keep conversion at the UI boundary so saved
// map geometry retains its original orientation.
export function mapAngleToBearing(angle) {
  return Number.isFinite(angle) ? wrapDirection(angle + 90) : NaN;
}

export function bearingToMapAngle(bearing) {
  return Number.isFinite(bearing) ? wrapDirection(bearing - 90) : NaN;
}

export function keyboardDirection(value, key) {
  const steps = { ArrowRight: 1, ArrowUp: 1, ArrowLeft: -1, ArrowDown: -1, PageUp: 10, PageDown: -10 };
  if (key === 'Home') return 0;
  if (key === 'End') return 360;
  if (!(key in steps)) return null;
  return wrapDirection(value + steps[key]);
}

export function validDirection(value) {
  return Number.isFinite(value) && value >= 0 && value <= 360;
}

function wrapDirection(value) {
  return (Math.round((((value % 360) + 360) % 360) * 100) / 100) % 360;
}
